import React from 'react';
import { Dropdown, Grid, Input, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import Button from '../../../components/Button';
import { FieldLabel } from '../../../styles';
import { maskCpf } from '../../../services/masks';

import { CommissioningFiltersState } from '../types';

type Props = {
  isBrokerAdmin: boolean;
  estateOptions: Array<{ key: string; text: string; value: string }>;
  filters: CommissioningFiltersState;
  setFilters: React.Dispatch<React.SetStateAction<CommissioningFiltersState>>;
  onSearch: () => void;
  onClear: () => void;
};

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 14px;

  @media (max-width: 991px) {
    justify-content: flex-start;
  }

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const searchTypeOptions = [
  { key: 'name', value: 'name', text: 'Nome' },
  { key: 'document', value: 'document', text: 'CPF' }
];

const statusOptions = [
  { key: 'all', value: '', text: 'Todos' },
  { key: 'ACTIVE', value: 'ACTIVE', text: 'Ativo' },
  { key: 'AWAITING_BIOMETRY', value: 'AWAITING_BIOMETRY', text: 'Aguardando biometria' }
];

const CommissioningFiltersBar: React.FC<Props> = ({
  isBrokerAdmin,
  estateOptions,
  filters,
  setFilters,
  onSearch,
  onClear
}) => {
  return (
    <Segment>
      <Grid>
        <Grid.Row>
          {isBrokerAdmin && (
            <Grid.Column computer={4} tablet={16} mobile={16}>
              <FieldLabel>Imobiliária</FieldLabel>
              <div style={{ width: '100%' }}>
                <Dropdown
                  style={{ width: '100%' }}
                  value={filters.estateId || ''}
                  placeholder="Selecionar..."
                  options={estateOptions}
                  search
                  selection
                  clearable
                  onChange={(_, { value }) =>
                    setFilters(prev => ({ ...prev, estateId: (value as string) || '' }))
                  }
                />
              </div>
            </Grid.Column>
          )}

          <Grid.Column computer={4} tablet={16} mobile={16}>
            <FieldLabel>Pesquisar por</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.type}
                placeholder="Selecionar..."
                options={searchTypeOptions}
                search
                selection
                onChange={(_, { value }) =>
                  setFilters(prev => ({
                    ...prev,
                    type: value as CommissioningFiltersState['type'],
                    argument: ''
                  }))
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column computer={isBrokerAdmin ? 4 : 5} tablet={16} mobile={16}>
            <FieldLabel>Termo de pesquisa</FieldLabel>
            <Input
              fluid
              value={filters.argument}
              onChange={(_, { value }) => {
                if (filters.type === 'document') {
                  setFilters(prev => ({ ...prev, argument: maskCpf(value) }));
                  return;
                }
                setFilters(prev => ({ ...prev, argument: value }));
              }}
            />
          </Grid.Column>

          <Grid.Column computer={isBrokerAdmin ? 4 : 3} tablet={16} mobile={16}>
            <FieldLabel>Status</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.status}
                placeholder="Selecionar..."
                options={statusOptions}
                selection
                onChange={(_, { value }) =>
                  setFilters(prev => ({
                    ...prev,
                    status: value as CommissioningFiltersState['status']
                  }))
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column computer={isBrokerAdmin ? 16 : 4} tablet={16} mobile={16}>
            <ActionsWrapper>
              <Button type="submit" text="Pesquisar" onClick={onSearch} />
              <Button light type="button" text="Limpar" onClick={onClear} />
            </ActionsWrapper>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default CommissioningFiltersBar;
